<template>
  <div class="container">
    <div v-if="loading">
      <div id="loader">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>

    <h4 class="cardD">
      Entidad Federativa en la que será firmada la Constitutiva
    </h4>

    <div class="row">
      <div class="col-md-6">
        <label>Entidad Federativa</label>
        <select :disabled="constitutiva.disabled" class="custom-select" v-model="constitutiva.selectedEntidad"
          @change="getMunicipios">
          <option v-for="option in constitutiva.optionsEntidades" :key="option.value">
            {{ option.text }}
          </option>
        </select>
      </div>

      <div class="col-md-6" v-if="hay_municipios">
        <label>Municipio</label>
        <select :disabled="constitutiva.disabled" class="custom-select" v-model="constitutiva.selectedMunicipio"
          @change="selectCorreduria($event)">
          <option v-for="option in constitutiva.optionsMunicipios" :key="option.value">
            {{ option.text }}
          </option>
        </select>
      </div>
    </div>

    <h4 class="cardD mt-5">Domicilio Social de la Sociedad</h4>
    <div class="row">
      <div class="col-md-4">
        <label>País</label>
        <select
          @change="fetchStatesByCountry"
          v-model="selectCountry"
          class="form-control"
          :disabled="true"
        >
          <option v-for="option in countries" :key="option.id">
            {{ option.name }}
          </option>
        </select>
      </div>
      <div class="col-md-4">
        <ValidationProvider
          name="entidad"
          rules="required"
          v-slot="{ errors }"
          :custom-messages="{ required: 'La entidad es obligatoria' }"
        >
          <label>Entidad Federativa</label>
          <select
            @change="fetchCitiesByState"
            v-model="selectState"
            class="form-control"
            :disabled="constitutiva.disabledEntidad || constitutiva.disabled"
          >
            <option v-if="isEmptyStates" value="noStates" selected>
              {{ noStatesText }}
            </option>
            <option v-for="option in states" :key="option.id">
              {{ option.name }}
            </option>
          </select>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-md-4" v-if="constitutiva.entidadDomicilio != 'Ciudad de México'">
        <label>Demarcación Territorial o Municipio</label>
        <select v-model="selectCity" class="form-control" :disabled="constitutiva.disabledEntidad || constitutiva.disabled">
          <option v-if="isEmptyCities" value="noCities" selected>
            {{ noCitiesText }}
          </option>
          <option v-for="option in cities" :key="option.id">
            {{ option.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-8">
        <label for="check_firma_oficina">La firma será en la oficina del Corredor </label>
        <b-form-checkbox id="check_firma_oficina" v-model="constitutiva.firma_oficina" :disabled="constitutiva.disabled">
        </b-form-checkbox>
        <label class="mb-12 leyenda blue-text-important" v-if="constitutiva.firma_oficina === false">
          Aplicará un costo extra para gastos de movilidad en caso de recabar firmas.
        </label>
      </div>
    </div>

    <div class="mt-4">
      <div class="">
        <b-button type="submit" class="btn-fill orange-btn bottom2" size="m"
          :disabled="constitutiva.disabled">Continuar</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "EntidadFederativa",

  props: {
    catCorredurias: { type: Array },
    constitutiva: { type: Object }
  },

  data() {
    return {
      loading: false,
      hay_municipios: true,

      noStatesText: "No hay estados disponibles",
      noCitiesText: "No hay ciudades disponibles",
      selectCountry: "",
      selectState: "",
      selectCity: "",
    };
  },

  computed: {
    ...mapState([
      "countries",
      "states",
      "cities",
      "isEmptyStates",
      "isEmptyCities",
    ]),

    ...mapGetters([
      "getCountries",
      "getStatesByCountryId",
      "getCitiesByStateId",
    ]),
  },

  watch: {
    "constitutiva.entidadDomicilio": {
      handler: function (val, oldVal) {
        // if (val) {
        //   storage.saveItem(
        //     "constitutiva.entidadDomicilio",
        //     this.constitutiva.entidadDomicilio
        //   );
        // }
      },
      deep: true,
    },
    "constitutiva.municipioDomicilio": {
      handler: function (val, oldVal) {
        // if (val) {
        //   storage.saveItem(
        //     "constitutiva.municipioDomicilio",
        //     this.constitutiva.municipioDomicilio
        //   );
        // }
      },
      deep: true,
    },
    "selectCountry": function (val, oldVal) {
      this.constitutiva.pais = this.selectCountry;
    },
    "selectState": function (val, oldVal) {
      this.constitutiva.entidadDomicilio = this.selectState;
    },
    "selectCity": function (val, oldVal) {
      this.constitutiva.municipioDomicilio = this.selectCity;
    }
  },

  created() {
    if (this.constitutiva.selectedEntidad != null) {
      this.getMunicipios();
    }
  },

  async mounted() {
    await this.fetchCountries();

    if (this.constitutiva.pais) {
      this.selectCountry = this.constitutiva.pais;

      await this.fetchStatesByCountry();

      if (this.constitutiva.entidadDomicilio) {
        await this.getExistState(this.constitutiva.entidadDomicilio);
      }
      if (this.constitutiva.municipioDomicilio) {
        await this.getExistCity(this.constitutiva.municipioDomicilio);
      }
    }
  },

  methods: {
    ...mapActions(["fetchCountries", "fetchStates", "fetchCities"]),

    async fetchStatesByCountry() {
      /**
       * Esta fx se llama solo si ya se tiene un país seleccionado
       */
      this.selectState = "";
      const pais = this.selectCountry;
      this.selectCity = "";
      // change store state cities to empty
      this.$store.commit("setCities", []);
      // Obtengo el id del país
      const paisId = await this.getIdCountry(pais);
      // obtengo el código de area del país
      const phoneCode = await this.getPhoneCode(pais);
      this.phoneKey = phoneCode;
      // this.currentCompareciente.telefonos[0].clave = phoneCode;
      // obtengo los estados del país
      await this.fetchStates(paisId);
      if (this.isEmptyStates) {
        this.selectState = "noStates";
        this.selectCity = "noCities";
      }
    },

    async fetchCitiesByState() {
      /**
       * Se llama para obtener las ciudades de un estado seleccionado
       */
      this.selectCity = "";
      const estado = this.selectState
      const estadoId = await this.getIdState(estado);
      await this.fetchCities(estadoId);
    },

    async getIdCountry(countryName) {
      /**
       * Obtiene el id del país seleccionado
       */
      const country = this.countries.find((c) => c.name === countryName);
      return country ? country.id : null;
    },

    async getIdState(stateName) {
      /**
       * Obtiene el id del estado seleccionado
       */
      const state = this.states.find((s) => s.name === stateName);
      return state ? state.id : null;
    },

    async getPhoneCode(countryName) {
      /**
       * Obtiene el código de área del país seleccionado
       */
      const country = this.countries.find((c) => c.name === countryName);
      return country ? country.phone_code : null;
    },

    async getExistCountry(countryName) {
      /**
       * Se llama si ya se tiene un país seleccionado
       */
      const currentCountry = countryName === "Mexico" ? "México" : this.constitutiva.pais;
      this.selectCountry = currentCountry;
    },

    async getExistState(stateName) {
      /**
       * Se llama si ya se tiene un estado seleccionado
       */
      const currentState = stateName
      this.selectState = currentState;
      const paisId = await this.getIdCountry(this.selectCountry);
      await this.fetchStates(paisId);
    },

    async getExistCity(cityName) {
      /**
       * Se llama si ya se tiene una ciudad seleccionada
       */
      const currentCity = cityName;
      this.selectCity = currentCity;
      const estadoId = await this.getIdState(this.selectState);
      await this.fetchCities(estadoId);
    },

    async getMunicipios() {
      try {
        this.constitutiva.optionsMunicipios = [];
        if (this.constitutiva.selectedEntidad == "Ciudad de México") {
          //no trae municipios y se oculta
          this.hay_municipios = false;
          this.constitutiva.selectedMunicipio = "";
        } else {
          this.hay_municipios = true;
          this.catCorredurias.forEach(element => {
            if (element.entidad === this.constitutiva.selectedEntidad) {
              const obj = {
                text: element.delegacion_municipio,
                value: element.corredurias_id
              };
              this.constitutiva.optionsMunicipios.push(obj);
            }
          });
        }
      } catch (error) { }
    }

    // async selectCorreduria(event) {
    //   //aqui solo se guardan los nuevos campos consti: entidad y municipio
    //   // this.constitutiva.corredurias_id = event.target.value;
    // }
  }
};
</script>
